import React, { Component } from 'react';


import ManagedDistanceInput from '../../forms/ManagedDistanceInput.js';
import ShowIff from '../../ui/ShowIff.js';
import Checkbox from '../../forms/Checkbox.js';
import api from '../../../api/index.js';
import MapTableInterface from '../../forms/MapTableInterface.js';
import DatePicker from "react-datepicker";
import InputWrapper from '../../forms/InputWrapper.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEraser } from '@fortawesome/free-solid-svg-icons'

import "react-datepicker/dist/react-datepicker.css";
import './form.scss';

class FieldForm extends Component {
	constructor(props) {
		super(props);
		console.log(props);
		this.state = {
			FieldID: props.FieldID || false,
			VarietyID: props.VarietyID || false,
			FarmID: props.FarmID || false,
			FieldNumber: props.FieldNumber || '',
			Acres: props.Acres || 0,
			LeaseChecked: (this.props.hasOwnProperty('LeaseFrom') && props.LeasedFrom !== null) || false,
			LeasedFrom: props.LeasedFrom || 0,
			RowSpacing: props.RowSpacing || 0,
			PlantSpacing: props.PlantSpacing || 0,
			StartDate: api.date(props.StartDate) || new Date(),
			LeaseDate: api.date(props.LeaseDate),
			DiscontinuedDate: api.date(props.DiscontinuedDate),
		};
	}
	
	onChange = (e) => {
		console.log(e);
		const v = e.target.value.value || e.target.value;
		this.setState({[e.target.name]: v}, ()=>{console.log(this.state);});
	}
	
	onDateChange = (date) => {
		console.log("On date change", date);
		this.setState({
			StartDate: date
		});
	}

	onDiscontinuedDateChange = (date) => {
		this.setState({
			DiscontinuedDate: date
		});
	}

	leaseChange = (e) => {
		this.setState({[e.target.name]: e.target.checked});
	}
	
	onLeaseDateChange = (date) => {
		this.setState({
			LeaseDate: date
		});
	}
	
	clearLeaseDate = (e) => {
		e.stopPropagation();
		e.preventDefault();
		this.setState({LeaseDate: null});
	}
	
	onSubmit = async (e) => {
		e.preventDefault();

		// Format the dates before we send them
		const fielddata = Object.assign({}, this.state);
		fielddata['StartDate'] = fielddata['StartDate'].api();
		if (fielddata['LeaseDate'] != null)
			fielddata['LeaseDate'] = fielddata['LeaseDate'].api();

		if (this.props.discontinued && fielddata['DiscontinuedData'] != null)
			fielddata['DiscontinuedDate'] = fielddata['DiscontinuedDate'].api();
		else
			delete fielddata.DiscontinuedData;


		if (this.state.FieldID === false) {
			if (this.props.mode === "replant") {
				api.error({message: "You can't replant a field that doesn't exist!"});
				return;
			}
			
			try {
				let r = await api.post('farms/' + this.props.FarmID + '/fields/', fielddata);
				api.success('Field added', r);
				if (this.props.onAdded)
					this.props.onAdded(r);
			} catch(e) {
				api.handleExceptions(e);
			};
		} else {
			const suffix = this.props.mode === "replant" ? "/replant" : "";
			try {
				let r = await api.put('farms/' + this.props.FarmID + '/fields/' + this.props.FieldID + suffix, fielddata);
				api.success('Field updated', r);
				if (this.props.onUpdated)
					this.props.onUpdated(r);
			} catch(e) {
				api.handleExceptions(e);
			};
		}
	}
	
	
	
	onFieldAdded = (id) => {
		if (this.props.onAdded)
			this.props.onAdded(id);
	}
	
	
	
	componentDidUpdate(prevProps) {
		const data = this.props || [];
		const fid = data.FieldID || false;
		if (this.state.FieldID !== fid) {
			console.log("Updating field");
			this.setState({
				FieldID: data.FieldID || false,
				VarietyID: data.VarietyID || false,
				FarmID: data.FarmID || false,
				FieldNumber: data.FieldNumber || '',
				Acres: data.Acres || 0,
				LeaseChecked: data.LeasedFrom || false,
				LeasedFrom: data.LeasedFrom || 0,
				RowSpacing: data.RowSpacing || 0,
				PlantSpacing: data.PlantSpacing || 0
			});
		}
	} 
	
	render() {
		const discontinued = !this.props.discontinued ? '' : <>
				<label>Discontinued Date</label>
				<InputWrapper label=""  info="The date this field went out of service.">
				<DatePicker
						selected={this.state.DiscontinuedDate}
						onChange={this.onDiscontinuedDateChange}
					/>
				</InputWrapper>
				</>;
		return (
			<div>
				<form onSubmit={this.onSubmit} className="field-form">
						<label>Field Number</label>
						<input type="text" name="FieldNumber" placeholder="Field number" value={this.state.FieldNumber} onChange={this.onChange} />
						<label>Field start (planted) date</label>
						<div className="StartDate">
						<DatePicker
							selected={this.state.StartDate}
							onChange={this.onDateChange}
						/>
						</div>
						<label>Variety</label>
						<MapTableInterface 
							maptable="Varieties"
							parents={["Crop"]}
							groupby="Crop"
							name="VarietyID"
							onChange={this.onChange}
							value={this.state.VarietyID}
						/>
						<label>Acres</label>
						<input type="text" name="Acres" placeholder="Acres" value={this.state.Acres} onChange={this.onChange} />
						<label>RowSpacing</label>
						<ManagedDistanceInput name="RowSpacing" placeholder="Row spacing" value={this.state.RowSpacing} onChange={this.onChange} />
						<label>PlantSpacing</label>
						<ManagedDistanceInput name="PlantSpacing" placeholder="Plant spacing" value={this.state.PlantSpacing} onChange={this.onChange} />
						<hr />
						<label><Checkbox name="LeaseChecked" checked={this.state.LeaseChecked} onChange={this.leaseChange} />
							{this.state.LeaseChecked ? ' This field is leased, by' : ' Is this field leased? '} 
						</label>
						<ShowIff iff={this.state.LeaseChecked}>
							<MapTableInterface 
								maptable="LeaseCompanies" 
								value={this.state.LeasedFrom} 
								name="LeasedFrom" 
								onChange={this.onChange} 
							/>
						</ShowIff>
						<InputWrapper label="As of: "  info="If this is a new farm, you can leave the lease date blank.  This signifies that the field started this way. Click the clear button to empty it.">
						<DatePicker
							id="leaseDate"
							selected={this.state.LeaseDate}
							onChange={this.onLeaseDateChange}
						/>
						<button onClick={this.clearLeaseDate} className="block plus" title="Clear the date"><FontAwesomeIcon icon={faEraser} className="eraserIcon" /></button>
						</InputWrapper>
						<hr />
						{discontinued}
						<input type="submit" value={this.state.FieldID ? "Save this field" : "Add this field"} />
				</form>
			</div>
		);
	}
}

export default FieldForm;
